import { useRouteError, Link, isRouteErrorResponse } from 'react-router-dom';
import { Warning } from '@phosphor-icons/react';

import { Button } from '../components/ui/Button';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import pt from '../locales/pt';

export function ErrorPage() {
  const error = useRouteError();
  const isRouteError = isRouteErrorResponse(error);
  const status = isRouteError ? error.status : 500;
  const message = isRouteError
    ? error.statusText
    : error?.message || pt.common.errorBody;

  return (
    <div className="container-app py-10">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-danger-700">
            <Warning className="h-5 w-5" aria-hidden />
            {pt.common.errorTitle}
          </CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        <div className="mt-4 flex items-center justify-between">
          <span className="tnum text-xs font-medium uppercase text-muted-foreground/70">
            {status}
          </span>
          <Button asChild variant="ghost">
            <Link to="/">{pt.common.back}</Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
